import { render, staticRenderFns } from "./TypesView.vue?vue&type=template&id=11a741bf"
import script from "./TypesView.vue?vue&type=script&lang=js"
export * from "./TypesView.vue?vue&type=script&lang=js"
import style0 from "./TypesView.vue?vue&type=style&index=0&id=11a741bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports